<div class="ngx-dialog goreact-modal ai-trial-success-dialog">
	<div class="goreact-modal-header">
		<h4 class="modal-title"
			[innerHTML]="'ai-trial-success-dialog_title' | translate">
		</h4>
		<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<img alt="" src="https://staticassets.goreact.com/ai-trial-success.png" />
		<p [innerHTML]="'ai-trial-success-dialog_body' | translate"></p>
	</div>
	<div class="goreact-modal-footer">
		<button class="primary-btn" (click)="close()">
			{{ 'common_done' | translate }}
		</button>
	</div>
</div>
